<template>
    <td class="table-td" @click="onCellClicked">
        <slot></slot>
    </td>
</template>

<script>
export default {
    name: "TagTableCell",
    methods: {
        onCellClicked() {
            this.$emit('click-cell')
        }
    },
}
</script>

<style scoped>
.table-td{
    text-align: left;
    border: 1px solid #ccc;
    font-size: 11px;
}
</style>